import { render, staticRenderFns } from "./ExternalForms.vue?vue&type=template&id=26c103f5&scoped=true"
import script from "./ExternalForms.vue?vue&type=script&lang=ts"
export * from "./ExternalForms.vue?vue&type=script&lang=ts"
import style0 from "./ExternalForms.vue?vue&type=style&index=0&id=26c103f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c103f5",
  null
  
)

export default component.exports